import TooltipText from "../../components/inputComponents/TooltipText";
import { AllocateDates } from "../../components/selectComponents/AllocateDates";

interface PromotionDatesSetupProps {
}

export const PromotionDatesSetupComponent: React.FC<PromotionDatesSetupProps> = () => {
  return (
    <>
      <TooltipText
        text="Promotion Dates"
        textVariant="h6"
        tooltip="The dates were automatically inherited from the timeline selected for the campaign. If the timeline is different for this promotion, make sure to select the applicable start and end date here."
      />
      <AllocateDates
        description='Select a start and end date for the overall duration of the promotion.'
        datetime={true}
        formikStartDate={'startDate'}
        formikEndDate={'endDate'}
        formikTimezoneValue={'timezone'}
        minStartDate={Date.now()}
        datesClass='copy-promo date-box'
        containerSpacing={2}
        startEndDateColumns={6}
        timeZoneColumns={12}
      />
    </>
  );
};